import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { TodoSteps } from '../../../helpers/schema';

export const schema = z.object({
  todoId: z.string().min(1),
  title: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  step: Selectable<TodoSteps>;
};

export const createTodoStep = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/todos/steps/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
